module.exports = __webpack_public_path__ + "img/convenio.c9e38186.png";